/* This is generated code, don't alter */
var IfcStructuralCurveMemberTypeEnum;
(function (IfcStructuralCurveMemberTypeEnum) {
    IfcStructuralCurveMemberTypeEnum[IfcStructuralCurveMemberTypeEnum["RIGID_JOINED_MEMBER"] = 0] = "RIGID_JOINED_MEMBER";
    IfcStructuralCurveMemberTypeEnum[IfcStructuralCurveMemberTypeEnum["PIN_JOINED_MEMBER"] = 1] = "PIN_JOINED_MEMBER";
    IfcStructuralCurveMemberTypeEnum[IfcStructuralCurveMemberTypeEnum["CABLE"] = 2] = "CABLE";
    IfcStructuralCurveMemberTypeEnum[IfcStructuralCurveMemberTypeEnum["TENSION_MEMBER"] = 3] = "TENSION_MEMBER";
    IfcStructuralCurveMemberTypeEnum[IfcStructuralCurveMemberTypeEnum["COMPRESSION_MEMBER"] = 4] = "COMPRESSION_MEMBER";
    IfcStructuralCurveMemberTypeEnum[IfcStructuralCurveMemberTypeEnum["USERDEFINED"] = 5] = "USERDEFINED";
    IfcStructuralCurveMemberTypeEnum[IfcStructuralCurveMemberTypeEnum["NOTDEFINED"] = 6] = "NOTDEFINED";
})(IfcStructuralCurveMemberTypeEnum || (IfcStructuralCurveMemberTypeEnum = {}));
const IfcStructuralCurveMemberTypeEnumCount = 7;
export { IfcStructuralCurveMemberTypeEnum, IfcStructuralCurveMemberTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcStructuralCurveMemberTypeEnum = new Int32Array([486]);
let prefixSumAddressIfcStructuralCurveMemberTypeEnum = new Uint32Array([0, 13, 25, 32, 53, 73, 92, 108]);
let slotMapIfcStructuralCurveMemberTypeEnum = new Int32Array([5, 6, 2, 0, 4, 1, 3]);
let encodedDataIfcStructuralCurveMemberTypeEnum = (new TextEncoder()).encode(".USERDEFINED..NOTDEFINED..CABLE..RIGID_JOINED_MEMBER..COMPRESSION_MEMBER..PIN_JOINED_MEMBER..TENSION_MEMBER.");
let IfcStructuralCurveMemberTypeEnumSearch = new MinimalPerfectHash(gMapIfcStructuralCurveMemberTypeEnum, prefixSumAddressIfcStructuralCurveMemberTypeEnum, slotMapIfcStructuralCurveMemberTypeEnum, encodedDataIfcStructuralCurveMemberTypeEnum);
export { IfcStructuralCurveMemberTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcStructuralCurveMemberTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcStructuralCurveMemberTypeEnumSearch, input, cursor, endCursor);
}
